import { useState } from 'react';
import { heatList, topicChips, type HeatItem } from '../data';

function TrendMark({ item }: { item: HeatItem }) {
  if (item.trend === 'up') {
    return <span className="inline-flex items-center gap-1 text-xs text-primary-600"><i className="ri-arrow-up-line"></i>{item.delta}</span>;
  }
  if (item.trend === 'down') {
    return <span className="inline-flex items-center gap-1 text-xs text-foreground-400"><i className="ri-arrow-down-line"></i>{item.delta}</span>;
  }
  return <span className="inline-flex items-center gap-1 text-xs text-accent-700"><i className="ri-subtract-line"></i>{item.delta}</span>;
}

export default function HeatLadder() {
  const [activeTag, setActiveTag] = useState<string>('全部');
  const tags = ['全部', ...topicChips.slice(0, 4)];

  return (
    <section id="heat" className="border-b border-foreground-900/10 bg-background-100/40">
      <div className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="kicker text-xs text-primary-600">实时热度阶梯 · HOT LADDER</p>
            <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
              正在升温的实时热度榜
            </h2>
          </div>
          <button className="hidden whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600 sm:inline-flex">
            完整榜单 <i className="ri-arrow-right-up-line"></i>
          </button>
        </div>

        {/* tag 分段切换 */}
        <div className="mt-5 flex flex-wrap items-center gap-2">
          {tags.map((t) => (
            <button
              key={t}
              onClick={() => setActiveTag(t)}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-sm transition-colors ${
                activeTag === t
                  ? 'bg-foreground-950 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200/60'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* 榜单列表 */}
        <div className="mt-5 grid grid-cols-1 gap-x-8 lg:grid-cols-2">
          {heatList.map((item) => (
            <article
              key={item.rank}
              className="group flex items-center gap-4 border-b border-foreground-900/5 py-3 last:border-0"
            >
              <span
                className={`flex w-9 shrink-0 items-center justify-center font-heading text-xl font-semibold tabular-nums ${
                  item.rank <= 3 ? 'text-primary-600' : 'text-foreground-300'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-[15px] font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                  <a href="#focus" className="truncate">{item.title}</a>
                </h3>
                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500"></i>{item.heat} 热度
                  </span>
                  <span
                    className={`inline-flex items-center rounded px-1.5 py-0.5 text-[11px] ${
                      item.isHot ? 'bg-primary-100 text-primary-800' : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                  <TrendMark item={item} />
                </div>
              </div>
              <i className="ri-arrow-right-up-line text-foreground-300 opacity-0 transition-opacity group-hover:opacity-100"></i>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}